import { useLayoutEffect, useRef, useState } from 'react';

export const useVerticalAlignIfSingleLine = (
	title?: string | null | undefined,
) => {
	const titleRef = useRef<HTMLParagraphElement>(null);
	const [alignItems, setAlignItems] = useState<'center' | 'flex-start'>(
		'flex-start',
	);

	// biome-ignore lint/correctness/useExhaustiveDependencies: <explanation>
	useLayoutEffect(() => {
		if (!title || !titleRef.current) return;

		if (titleRef.current) {
			const lineHeight = Number.parseFloat(
				getComputedStyle(titleRef.current).lineHeight,
			);
			const lines = titleRef.current.clientHeight / lineHeight;
			if (lines < 3) setAlignItems('center');
		}
	}, [title]);

	return { alignItems, titleRef };
};
